export const ROUTES = {
  home: '/',
  dataGovernors: '/data-governors',
  lineManager: '/linemanager',
  login: '/login',
  retryRequest: '/retry-request',
} as const
